import { Col, Row, Tooltip } from "antd";
import React from "react";
import InputWithLabel from "../../../component/FormInput/InputWithLabel";
import SelectWithLabel from "../../../component/FormInput/SelectWithLabel";
import CommonFilterTable from "../../../component/table/TableFiltter";
import { INPUT_TYPE, lang, MODE_SCREEN } from "../../../constants/common.const";

const ListUsefulLifeMaster = ({
  currentNode,
  setCurrentNode,
  dataSearch,
  setDataSearch,
  dataSource,
  onChangeCate,
  mode,
  setFirstNodeFilter,
}) => {
  const handleChangeDataSearch =
    (key, type = INPUT_TYPE.INPUT) =>
    (e) => {
      const value = !e.target ? e : e.target.value;
      setDataSearch({
        ...dataSearch,
        [key]: {
          ...dataSearch[key],
          value,
        },
      });
      onChangeCate(value);
    };

  const fields = [
    {
      title: lang.TYPE_OF_WORK,
      key: "equipmentCategory",
      value: dataSearch.equipmentCategory,
      type: INPUT_TYPE.SELECT,
    },
  ];
  const renderInputWithLabel = (item) => {
    switch (item.type) {
      case INPUT_TYPE.INPUT: {
        return (
          <InputWithLabel
            onChange={handleChangeDataSearch(item.key, item.type)}
            valueObj={item.value}
            label={item.title}
          />
        );
      }
      case INPUT_TYPE.SELECT: {
        return (
          <SelectWithLabel
            disabled={mode !== MODE_SCREEN.VIEW}
            onChange={handleChangeDataSearch(item.key, item.type)}
            valueObj={item.value}
            className="w100"
            label={item.title}
            options={item.value.options || []}
            allTitle={true}
          />
        );
      }
      default: {
        return (
          <InputWithLabel
            onChange={handleChangeDataSearch(item.key, item.type)}
            a
            valueObj={item.value}
            label={item.title}
          />
        );
      }
    }
  };
  const renderInputs = fields.map((item) => (
    <Col key={item.key} lg={24} sm={24} xs={24}>
      {renderInputWithLabel(item)}
    </Col>
  ));

  const renderText = (text) => (
    <Tooltip title={text}>
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </div>
    </Tooltip>
  );

  const columns = [
    {
      title: lang.TYPE_OF_WORK_NAME,
      dataIndex: "equipmentName",
      align: "start",
      width: 150,
      render: renderText,
    },
    {
      title: lang.MAIN_CATEGORY,
      dataIndex: "equipmentHigher",
      align: "start",
      width: 150,
      render: renderText,
    },
    {
      title: lang.SUB_CATEGORY,
      dataIndex: "equipmentMiddle",
      width: 150,
      align: "start",
      render: renderText,
    },
    {
      title: lang.SMALL_CATEGORY,
      dataIndex: "equipmentMinor",
      width: 150,
      align: "start",
      render: renderText,
    },

    {
      title: lang.MATERIAL_NAME,
      dataIndex: "materialName",
      width: 150,
      align: "start",
      render: renderText,
    },
    {
      title: lang.STANDARD_SERVICE_LIFE,
      dataIndex: "standardUsefulLife",
      width: 150,
      align: "center",
      type: "number",
      render: renderText,
    },

    {
      title: lang.TARGET_SERVICE_LIFE,
      dataIndex: "targetUsefulLife",
      width: 150,
      align: "center",
      type: "number",
      render: renderText,
    },

    {
      title: lang.DISPLAY_ORDER,
      dataIndex: "displayOrder",
      width: 150,
      align: "center",
      type: "number",
      render: renderText,
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>{renderInputs}</Row>

      <CommonFilterTable
        setFirstNodeFilter={setFirstNodeFilter}
        rowClassName={(record) =>
          currentNode && record.id === currentNode.id
            ? "selected-row-facilityMaster"
            : ""
        }
        onRow={(record) => ({ onClick: () => setCurrentNode(record) })}
        rowKey="id"
        data={dataSource.data}
        columns={columns}
        className="table-selected-custom table-equipment-custome my-custom-table mt10"
        scrollY={"calc(100vh - 328px)"}
        paging={true}
        tableKey="useful"
        addedLeft={160}
        disabledFilter={mode !== MODE_SCREEN.VIEW}
        idFocus={dataSource.idFocus}
      />
    </div>
  );
};

export default React.memo(ListUsefulLifeMaster);
